import { defineComponent } from 'vue';
import { informationCircleSharp } from 'ionicons/icons';
import { IonIcon, IonItem, IonLabel } from "@ionic/vue";
import store from "@/store";
export default defineComponent({
    name: "SettingsButton",
    setup() {
        return { informationCircleSharp };
    },
    components: {
        IonItem,
        IonIcon,
        IonLabel
    },
    methods: {
        showHelp() {
            store.commit('setHelpModalShow', true);
        }
    }
});
